import React, { useMemo, useState } from 'react';
import { BookOpen } from 'lucide-react';
import { Heading } from '../../layout';
import { useUIColors } from '../../../hooks/useTheme';
import { FORMULA_STATUSES, IP_FORMULAS } from './ipCatalog';

const IpFormulasWorkspace = ({ isDarkMode = false }) => {
  const ui = useUIColors();
  const [status, setStatus] = useState('Todas');

  const items = useMemo(
    () => IP_FORMULAS.filter((item) => status === 'Todas' || item.status === status),
    [status]
  );

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div>
        <Heading level={2} isDarkMode={isDarkMode}>
          <BookOpen size={22} style={{ marginRight: 8, verticalAlign: 'middle' }} />
          Fórmulas
        </Heading>
        <p style={{ margin: '6px 0 0', fontSize: 13, color: ui.muted }}>
          Registro interno de fórmulas protegidas. Aquí no se publica el detalle de receta, solo la ficha de PI.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {FORMULA_STATUSES.map((item) => {
          const active = status === item;
          return (
            <button
              key={item}
              type="button"
              onClick={() => setStatus(item)}
              style={{
                height: 30,
                padding: '0 12px',
                borderRadius: 999,
                border: `1px solid ${active ? ui.interactive || '#16a34a' : ui.border}`,
                background: active ? ui.interactive || '#16a34a' : 'transparent',
                color: active ? ui.textOnAccent || '#fff' : ui.text,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {item}
            </button>
          );
        })}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 14,
        }}
      >
        {items.map((item) => (
          <article
            key={item.id}
            style={{
              border: `1px solid ${ui.border}`,
              borderRadius: 14,
              background: ui.panel,
              padding: 16,
              display: 'grid',
              gap: 10,
              minWidth: 0,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: ui.muted, letterSpacing: '0.04em' }}>
                  {item.code}
                </div>
                <h3 style={{ margin: '4px 0 0', fontSize: 16, color: ui.text }}>{item.name}</h3>
              </div>
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  padding: '4px 8px',
                  borderRadius: 999,
                  background: item.status === 'Vigente'
                    ? isDarkMode ? '#14532d' : '#dcfce7'
                    : isDarkMode ? '#422006' : '#fef3c7',
                  color: item.status === 'Vigente'
                    ? isDarkMode ? '#bbf7d0' : '#166534'
                    : isDarkMode ? '#fde68a' : '#92400e',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.status}
              </span>
            </div>
            <p style={{ margin: 0, fontSize: 13, color: ui.muted, lineHeight: 1.45 }}>{item.summary}</p>
            <dl style={{ margin: 0, display: 'grid', gap: 8 }}>
              {item.properties.map((prop) => (
                <div
                  key={prop.label}
                  style={{ display: 'grid', gridTemplateColumns: '110px 1fr', gap: 8, fontSize: 12 }}
                >
                  <dt style={{ color: ui.muted, margin: 0 }}>{prop.label}</dt>
                  <dd style={{ margin: 0, color: ui.text, fontWeight: 600 }}>{prop.value}</dd>
                </div>
              ))}
            </dl>
            <div style={{ fontSize: 12, color: ui.muted }}>Clasificación: {item.secrecy}</div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default IpFormulasWorkspace;
